import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsOneToMany } from '../../../hooks/use-is-one-to-many';
import { useMultiAddresses } from '../../../hooks/use-multi-addresses';
import { AddressSelectionIndicator } from '../../address-selection-indicator/address-selection-indicator';
import { EnvelopeFormHeaderProps } from '../address-form-types';
import styles from '../address-form.module.scss';
import { Heading, Text } from '@dotcom/crown-ui';

export const Header = ({ formTitle, isRecipientAddress }: EnvelopeFormHeaderProps) => {
  const { t } = useTranslation();
  const isOneToMany = useIsOneToMany();
  const { shouldUseMultiAddresses } = useMultiAddresses();

  return (
    <>
      <header className={styles.header}>
        <div className={styles['title-container']}>
          <Heading as="h2" className={styles['title']} data-testid="address-form-title" styleVariant="subtitle">
            {formTitle}
          </Heading>
          {shouldUseMultiAddresses && isRecipientAddress && <AddressSelectionIndicator />}
        </div>
        {isOneToMany &&
          (isRecipientAddress ? (
            <Text as="span" data-testid="address-form-description" color="textPrimary">
              {t('addressForm.recipientDescription')}
            </Text>
          ) : (
            <Text as="span" data-testid="address-form-description" color="textPrimary">
              {t('addressForm.senderDescription')}
            </Text>
          ))}
      </header>
    </>
  );
};
